import { yup } from '@framework/validation/initYup.ts';
import { type YupArraySchema } from '@framework/validation/YupArraySchema.ts';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema.ts';
import { LazyWidgetSchema } from '../../../LazyWidgetSchema.ts';
import { type Widget } from '../../../Widget.ts';
import { type IContainerWidget } from '../IContainerWidget.ts';

export const CommonContainerWidgetConfigSchema: yup.ObjectSchema<IContainerWidget> =
  CommonBaseWidgetSchema.shape({
    children: yup
      .array()
      .required()
      // Valido il form nella sua totalità solo se non è una bozza (e.g. quando viene pubblicato)
      .when('$isDraft', ([isDraft], schema) => {
        if (!isDraft) {
          return schema.of(LazyWidgetSchema).required();
        }
        return schema.optional().default([]);
      })
      .default([] as Widget[]) satisfies YupArraySchema<Widget>,
  })
    .required()
    .noUnknown();
